import { IProposalData } from 'source/NFR.types';

const ProposalData: React.FC<IProposalData> = ({ items = [] }) => {
  if (!items?.length) return null;
  return (
    <div className="proposal-data">
      {items?.map(item => (
        <div className="proposal-data--item" key={item.label}>
          <span className="proposal-data--label">{item.label}</span>
          <span className="proposal-data--value">
            {item.text && <span className="proposal-data--value-text">{item.text}</span>}
            {item.links?.map(link => (
              <a className="proposal-data--link" href={link.url} key={link.text}>
                <span>{link.text}</span>
              </a>
            ))}
          </span>
        </div>
      ))}
    </div>
  );
};

ProposalData.displayName = 'ProposalData';

export default ProposalData;
